module.exports = __webpack_public_path__ + "static/media/bunu_jump_run.17bec8d0.gif";